import React from 'react'
import styles from './SpacerField.module.css'

const SpacerField = () => <div className={styles.spacer}></div>

export default SpacerField
